import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    HostListener,
    inject,
    Input,
    OnInit,
    Output,
} from '@angular/core';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faSort, faSortDown, faSortUp} from '@fortawesome/free-solid-svg-icons';
import {ICON_STYLE_DEFAULTS} from '../icon-style';

export type SortDirection = 'asc' | 'desc';

export interface Sorting {
    column: string;
    direction: SortDirection;
}

export type SortingType<T> = {
    column: keyof T;
    direction: SortDirection;
};

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: '[app-sortable-table-header]',
    templateUrl: './sortable-table-header.component.html',
    styleUrls: ['./sortable-table-header.component.scss'],
    imports: [FontAwesomeModule],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SortableTableHeaderComponent implements OnInit {
    @Input({required: true}) column!: string;
    @Input({required: true}) label!: string;
    @Input() initialDirection: SortDirection | null = null;
    @Output() sort = new EventEmitter<Sorting>();

    readonly faSort = faSort;
    readonly faSortUp = faSortUp;
    readonly faSortDown = faSortDown;

    private privateDirection: SortDirection | null = null;

    private readonly iconStyleDefaults = inject(ICON_STYLE_DEFAULTS, {optional: true});

    constructor(private cdr: ChangeDetectorRef) {}

    get iconStyleResolved(): 'svg' | 'fontawesome' {
        return this.iconStyleDefaults?.iconStyle === 'fontawesome' ? 'fontawesome' : 'svg';
    }

    get direction(): SortDirection | null {
        return this.privateDirection;
    }

    set direction(direction: SortDirection | null) {
        this.privateDirection = direction;
        this.cdr.markForCheck();
    }

    ngOnInit(): void {
        this.privateDirection = this.initialDirection;
    }

    @HostListener('click')
    rotate(): void {
        switch (this.privateDirection) {
            case 'asc':
                this.privateDirection = 'desc';
                break;
            case 'desc':
                this.privateDirection = 'asc';
                break;
            default:
                this.privateDirection = 'asc';
                break;
        }
        this.sort.emit({column: this.column, direction: this.privateDirection});
    }
}
